import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2c0d0a71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-name-text" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import type { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import type { BaselineTerminalTopItem } from '@/views/dashboard/safe-status/base-line/_components/base-line-header/base-line-header.service'
import type { BaseLineItem } from '@/views/dashboard/safe-status/base-line/base-line.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseline-terminal-top-ranking',
  props: {
    data: { default: () => [] },
    loading: { type: Boolean, default: false },
    onViewMore: { type: Function, default: undefined }
  },
  emits: ["detail"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

const emit = __emit

const props = __props

function onRankingItemClick (row: RankingItem) {
  const dev = row.device as BaseLineItem | undefined
  if (dev?.device_id) {
    emit('detail', dev)
  }
}

const rankingCardOpt = computed(() => {
  void locale.value
  return {
    onViewMore: props.onViewMore,
    viewMoreText: t('baselineDashboard.viewMore')
  }
})

const chartData = computed(() =>
  (props.data || []).map(item => ({
    name: item.group_name
      ? `${item.computer_name} / ${item.group_name}`
      : item.computer_name,
    count: item.substandard_count || 0,
    device_id: item.device?.device_id,
    device: item.device
  }))
)

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('baselineDashboard.chartTerminalTop5'),
    data: chartData.value,
    "show-time-range": false,
    unit: _ctx.$t('baselineDashboard.unitItems'),
    "name-key": "name",
    "max-items": 5,
    "card-size": "second",
    loading: _ctx.loading,
    "card-opt": rankingCardOpt.value,
    "row-clickable": "",
    "item-key-field": "device_id",
    onItemClick: onRankingItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    "item-name": _withCtx(({ item }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(item.name), 1)
    ]),
    _: 1
  }, 8, ["title", "data", "unit", "loading", "card-opt"]))
}
}

})